import React from "react";
import { useHistory } from "react-router";
import { useState } from "react/cjs/react.development";
import "./Register.css";

async function registerUser(credentials) {
  console.log("Started");
  return fetch("https://project-x-01.herokuapp.com/user/registration", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

function Register() {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const [error, setError] = useState();

  const [loading, setIsLoading] = useState(false);

  const history = useHistory();

  const handleSubmit = async (e) => {
    if (!username || !password || !email) {
      console.log("Wrong Creds");
      return;
    }
    e.preventDefault();
    setIsLoading(true);
    const token = await registerUser({
      username,
      email,
      password,
    });
    setIsLoading(false);
    if (token["isSuccessful"]) {
        history.push('/auth');
    } else {
        setError(token["error"])
    }
  };

  return (
    <div>
        {error && <h3>{error}</h3>}
      <form className="register-wrapper" onSubmit={handleSubmit}>
        <label>
          <p>Username</p>
          <input type="text" onChange={(e) => setUsername(e.target.value)} />
        </label>
        <label>
          <p>Password</p>
          <input
            type="password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <label>
          <p>Email</p>
          <input
            type="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <div>
          <button type="submit" className="button is-success mr-2">
            Submit
          </button>
        </div>
      </form>
      {loading && <p>Loading</p>}
    </div>
  );
}

export default Register;
